import clsx from 'clsx';
import { Flex } from '@nula/core-ui';
import styles from './editor-toolbar.module.css';

export { styles as toolbarStyles };

interface EditorToolbarProps {
  children: React.ReactNode;
  className?: string;
}

/** Shared floating toolbar surface for all editor bubble menus. */
export function EditorToolbar({ children, className }: EditorToolbarProps) {
  return (
    <Flex align="center" gap="xs" className={clsx(styles.toolbar, className)}>
      {children}
    </Flex>
  );
}

/** Vertical divider between toolbar groups. */
export function EditorToolbarDivider() {
  return <div className={styles.divider} />;
}
